<template lang="pug">
section
  s-page-title(:previous='true' title='Карточка клиента')
  client(:client='client' class='mb-4')
  v-card
    v-tabs(v-model='activeTab' color='white' slider-color='primary')
      v-tab Договора
      v-tab Запись на осмотр
      v-tab(v-if='payments.length') Платежи
      v-tab Сообщения

      //- Договора
      v-tab-item(:transition='false' :reverse-transition='false')
        deals(:deals='client.deals' :isLoading='isLoading')

      //- Запись на осмотр
      v-tab-item(:transition='false' :reverse-transition='false')
        schedule(
          @unassign='unassign'
          :schedule='client.schedule'
          :isLoading='isLoading'
        )

      //- Платежи
      v-tab-item(
        v-if='payments.length'
        :transition='false'
        :reverse-transition='false'
      )
        payments(:payments='payments' :isLoading='isLoading')

      //- Сообщения
      v-tab-item(:transition='false' :reverse-transition='false')
        messages(:messages='client.messages' :isLoading='isLoading')
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Client from './Client'
import Deals from './Deals'
import Schedule from './Schedule'
import Messages from './Messages'
import Payments from './Payments'

export default {
  props: ['id'],

  components: {
    Client,
    Deals,
    Schedule,
    Messages,
    Payments
  },

  data: () => ({
    activeTab: 0,
    client: {}
  }),

  created() {
    this.setClient()
  },

  methods: {
    async setClient() {
      this.client = await this.getClient()
    },

    async getClient() {
      try {
        return (await this.fetchSingle({ id: this.id })).data
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async unassign(assign) {
      if (
        !this.isScheduleLoading &&
        (await this.$confirm('Удалить запись на осмотр?'))
      ) {
        try {
          await this.destroy({ id: assign.id })
          this.setClient()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления записи')
        }
      }
    },

    ...mapActions('manager/clients', ['fetchSingle']),
    ...mapActions('schedule/schedule-assign', ['destroy'])
  },

  computed: {
    // Вернем договора, в которых были платежи,
    // отсортируем по дате последнего платежа
    payments() {
      let { deals } = this.client

      if (void 0 !== deals) {
        return deals
          .filter(x => x.pays)
          .map(x => ({
            ...x,
            pays: x.pays.reverse()
          }))
      }

      return []
    },

    ...mapGetters('manager/clients', ['isLoading']),
    ...mapGetters('schedule/schedule-assign', {
      isScheduleLoading: 'isLoading'
    })
  }
}
</script>
